//@https://github.com/w3c/IntersectionObserver 
import WindowRect from "./GetWindowRect";
import Event from "./event";
import IntersectionOb from "./intersectionOb";

function elShowFn(minTop, maxBottom) {
    var poll, throttle = 100;
    function checkElShow(el, minTop, maxBottom) {
        var coords = el.getBoundingClientRect();
        return parseInt(coords.top) >= -minTop && parseInt(coords.top) - maxBottom <= (parseInt(WindowRect().height))
    }
    this.checkElArr = [];
    this.minTop = minTop;
    this.maxBottom = maxBottom;
    this.addEventEls = [window];
    this.scrollFnc = () => {
        for (var i = this.checkElArr.length - 1; i >= 0; i--) {
            if (checkElShow(this.checkElArr[i].el, this.minTop, this.maxBottom)) {
                this.checkElArr[i].showFn && this.checkElArr[i].showFn();
                this.checkElArr.splice(i, 1);
                console.log(this.checkElArr);
                if (this.checkElArr.length == 0) {
                    // console.log(this.addEventEls,"------->>");
                    for (var j = 0; j < this.addEventEls.length; j++) {
                        Event.removeEvent(this.addEventEls[j], "scroll", this.scrollFncTimeout)
                    }
                }
            }
        }
    }
    //conso.
    this.scrollFncTimeout = () => {
        clearTimeout(poll);
        poll = setTimeout(this.scrollFnc, throttle);
    }
    //开始侦听
    this.listenerScroll = function (el, showfn) {
        console.log(this, el, showfn);
        if (checkElShow(el, this.minTop, this.maxBottom)) {
            showfn && showfn()
        } else {
            // console.log("添加到checkElArr");
            this.checkElArr.push({ el: el, showFn: showfn });
            if (this.checkElArr.length > 0) {
                for (var i = 0; i < this.addEventEls.length; i++) {
                    Event.addEvent(this.addEventEls[i], "scroll", this.scrollFncTimeout)
                }
            }
        }
    }
}
// Exit early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if (typeof window !== 'object'&&'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
        Object.defineProperty(window.IntersectionObserverEntry.prototype,
            'isIntersecting', {
                get: function () {
                    return this.intersectionRatio > 0;
                }
            });
    }
    module.exports = IntersectionOb;
} else {
    module.exports = elShowFn
}